import React from "react";
import ServiceSection from "./ServiceSection";
import { whyMeTranslation } from "data/services/translationServices";

const ListOfWhyMe = (props) => {
    return (
        <ServiceSection
            title={whyMeTranslation.mainTitle[props.language.language]}
        >
            <ul className="whyme-list">
                {whyMeTranslation.content.map((item, idx) => {
                    return (
                        <li key={`services-why-me-${idx}`} className="animate-fade-up">
                            <span><ion-icon name={item.icon}></ion-icon></span>
                            <h4>{item.title[props.language.language]}</h4>
                            <p>{item.text[props.language.language]}</p>
                        </li>
                    );
                })}
            </ul>
        </ServiceSection>
    );
};

export default ListOfWhyMe;
